import React from "react";
import {Input} from "antd";


const SearchField = ({onChangeHandler}) => {

    return (
        <Input
            placeholder="Search metahuts"
            className="bg-indigo-900 rounded-3xl search w-60 h-11 text-base text-white"
            allowClear
            prefix={<i className="icon-search text-xl"></i>}
            onChange={onChangeHandler}
        />
    )
}

export default SearchField;